import { Link } from "react-router-dom";
import flyerData from "../data/flyerData.json";
import "../styles/HomeNew.css";

export default function Flyers() {
    return (
        <div className="pg">

            {/* ── HERO ── */}
            <section className="hero" style={{ minHeight: "38svh" }}>
                <div className="hero__glow hero__glow--1" />
                <div className="hero__glow hero__glow--2" />
                <div className="hero__glow hero__glow--3" />
                <div className="hero__inner" style={{ gridTemplateColumns: "1fr" }}>
                    <div className="hero__text">
                        <p className="hero__kicker">For A Better Tomorrow</p>
                        <h1 className="hero__h1">
                            Event <span className="hero__accent">Flyers</span>
                        </h1>
                        <p className="hero__sub">
                            Browse flyers for FBT events, programs, and initiatives. Click any flyer to view the full version.
                        </p>
                    </div>
                </div>
            </section>

            {/* ── FLYERS GRID ── */}
            <section className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
                <div className="sec-hd">
                    <span className="sec-eye">Resources</span>
                    <h2 className="sec-h2">All Flyers</h2>
                    <p className="sec-sub">{flyerData.flyers.length} flyer{flyerData.flyers.length !== 1 ? "s" : ""} available.</p>
                </div>

                <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "1.25rem",
                }}>
                    {flyerData.flyers.map((flyer, i) => (
                        <Link
                            key={flyer.link}
                            to={`/flyer/${flyer.link}`}
                            className="lcard"
                            style={{
                                textDecoration: "none",
                                padding: 0,
                                overflow: "hidden",
                                gap: 0,
                                borderColor: i % 3 === 0 ? "var(--pu-200)" : i % 3 === 1 ? "var(--pk-200)" : "var(--gn-200)",
                            }}
                        >
                            {/* Thumbnail */}
                            <div style={{ width: "100%", aspectRatio: "3/4", overflow: "hidden", background: "var(--bdr)" }}>
                                <img
                                    src={`/images/flyers/${flyer.file}`}
                                    alt={flyer.name}
                                    loading="lazy"
                                    style={{
                                        width: "100%", height: "100%",
                                        objectFit: "cover", display: "block",
                                        transition: "transform .3s",
                                    }}
                                    onMouseEnter={e => (e.target.style.transform = "scale(1.05)")}
                                    onMouseLeave={e => (e.target.style.transform = "scale(1)")}
                                />
                            </div>

                            {/* Label */}
                            <div style={{
                                padding: ".85rem 1rem",
                                borderTop: `1.5px solid ${i % 3 === 0 ? "var(--pu-200)" : i % 3 === 1 ? "var(--pk-200)" : "var(--gn-200)"}`,
                                background: i % 3 === 0 ? "var(--pu-50)" : i % 3 === 1 ? "var(--pk-50)" : "var(--gn-50)",
                            }}>
                                <p style={{
                                    fontFamily: "var(--ff-head)",
                                    fontSize: ".88rem",
                                    fontWeight: 800,
                                    color: i % 3 === 0 ? "var(--pu-700)" : i % 3 === 1 ? "var(--pk-700)" : "var(--gn-700)",
                                    textAlign: "center",
                                }}>
                                    {flyer.name}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

        </div>
    );
}